import { render, staticRenderFns } from "./Lab.vue?vue&type=template&id=638dfa32&scoped=true&"
import script from "./Lab.vue?vue&type=script&lang=js&"
export * from "./Lab.vue?vue&type=script&lang=js&"
import style0 from "./Lab.vue?vue&type=style&index=0&id=638dfa32&lang=scss&scoped=true&"
import style1 from "./Lab.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638dfa32",
  null
  
)

export default component.exports